// extracted by mini-css-extract-plugin
export default {"back-btn":"BackButton_back-btn__loraj","back-btn-responsive":"BackButton_back-btn-responsive__DnMeV"};